import React from "react";
import Chart from "react-apexcharts";
import { falseData, trueData } from "../dummyData/targetData";

const DetectedPersonTimeline = ({ target, people }) => {
  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "50%",
      },
    },
    colors: ["#19607e"], // Warna sesuai gambar (merah dan biru)
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "14px",
      },
    },
    xaxis: {
      categories: ["Target Terdeteksi", "Orang Dikenali"], // Label sumbu X
      labels: {
        style: {
          fontSize: "12px",
          colors: "#BFC2C6",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "14px",
          colors: "#BFC2C6",
        },
      },
    },
  };

  const chartSeries = [
    {
      name: "Total target",
      data: [target, people], // Data sesuai dengan gambar
    },
  ];

  return (
    <div>
      <h2 className="font-semibold text-sm text-mo-content-text mx-4">
        Timeline Deteksi
      </h2>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="bar"
        height={120}
      />
    </div>
  );
};

export default DetectedPersonTimeline;
